import api from 'api'

const FETCH_REQUEST = 'realhub/chart/providerMetrics/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/chart/providerMetrics/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/chart/providerMetrics/FETCH_FAILURE'

// Initial State
const initialState = {
  result: {},
  loaded: false,
  loadedForKeys: [],
  loading: false,
  errors: [],
}

// Actions
export function fetchRequest(payload = {}){
  return {
    type: FETCH_REQUEST,
    loadedForKeys: payload.loadedForKeys,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    agencyId: payload.agencyId,
    data: payload.data,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function loadProviderMetrics(agency, options){
  const { id } = agency

  const key = `Agency${id}`

  return (dispatch, getState) => {
    // Set Loading
    const loadedForKeys = [...getState().charts.providerMetrics.loadedForKeys]
    if (!loadedForKeys.includes(key)){
      loadedForKeys.push(key)
    }

    dispatch(fetchRequest({ loadedForKeys }))

    const promise = api(`/admin/agencies/${id}/provider_metrics.json`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        dispatch(fetchSuccess({ agencyId: id, data: json.metrics }))

        return json
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  const { type, data } = action

  switch (type){
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        loadedForKeys: action.loadedForKeys || state.loadedForKeys,
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        result: {
          ...state.result,
          [action.agencyId]: { ...data },
        },
        loading: false,
        loaded: true,
        errors: [],
      })
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        errors: action.errors,
      })
    default:
      return state
  }
}
